module.exports = __webpack_public_path__ + "img/logo11.30e0fb46.png";